export const logoHorizontal = new URL('../public/logo-iglesia-2.png', import.meta.url).toString();
export const logoVertical = new URL('../public/logo-iglesia.png', import.meta.url).toString();

export const heroVideo = new URL(
  '../public/assets/tercercielo-ministracion-oracion-en-la-calle.mp4',
  import.meta.url,
).toString();
export const heroPoster = new URL('../public/assets/tercercielo-congregacion.jpg', import.meta.url).toString();

export const imgCongregacion = new URL('../public/assets/tercercielo-congregacion.jpg', import.meta.url).toString();
export const imgCongregacionWide = new URL('../public/assets/tercercielo-congregacion-2.jpg', import.meta.url).toString();
export const imgAdoracion = new URL('../public/assets/tercercielo-miniterio-adoracion.jpg', import.meta.url).toString();
export const imgPastores = new URL('../public/assets/tercercielo-pastores.jpg', import.meta.url).toString();

export const imgAlcanceOracion = new URL('../public/imagen-1.jpg', import.meta.url).toString();
export const imgAlcanceCalles = new URL('../public/imagen-3.jpg', import.meta.url).toString();
export const imgAlcanceCartel = new URL('../public/imagen-4.jpg', import.meta.url).toString();
